import { render, staticRenderFns } from "./configuration_activity_edit.vue?vue&type=template&id=c94e11b6"
import script from "./configuration_activity_edit.vue?vue&type=script&lang=js"
export * from "./configuration_activity_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports